import * as motorService from "../../../services/motor-service";
import * as commonServices from "../../../services/commonServices";
import store from "../../../redux/store";

const isLoggedInUser = () => {
  return store.getState().common.isLoggedIn;
};

export const getSadadPayment = async (data) => {
  return commonServices.getSadadPayment(data);
}

export const getCardPayment = async (data) => {
  return commonServices.getCardPayment(data);
}

export const createTamaraSession = async (data) => {
  return commonServices.createTamaraSession(data);
}

export const getApplePaySessionAPI =async (data)=>{
	return commonServices.getApplePaySession(data);
}

export const getApplePayTokenAPI =async (data)=>{
	return commonServices.getApplePayToken(data);
}

export const getApplePayPaymentsAPI =async (data)=>{
	return commonServices.getApplePayPayments(data);
}

export const validatePromoCode = async (data) => {
  return  motorService.validatePromoCode(data);
}
